import React, { useEffect, useState } from "react";
import "../styles/components/Header.css";
import logo from "../assets/logo1.jpg";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo + Heading (Clickable to scroll top) */}
        <div
          className="navbar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="Logo" />
          <h1 className="navbar-heading">JAI VISHWAKARMA ENTERPRISES</h1>
        </div>

        {/* Desktop Links */}
        <nav className="navbar-links">
          <a href="#about">About Us</a>
          <a href="#services">Services</a>
          <a href="#projects">Projects</a>
        </nav>

        {/* Right Button */}
        <div className="navbar-right">
          <a href="#contact" className="btn-get-intouch">
            Contact Now
          </a>
        </div>

        {/* Hamburger (Mobile only) */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div className="navbar-links mobile">
          <a href="#about">About Us</a>
          <a href="#services">Services</a>
          <a href="#projects">Projects</a>
          <a href="#contact" className="btn-get-in-touch">
            Contact Now
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
